import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Observable } from "rxjs/Observable";

@Injectable()
export class ErrorsService {
  ErrorStatus: any;
  ErrorStatusSubject = new BehaviorSubject<any>(this.ErrorStatus);

  constructor(private router: Router) {}

  handleError(error: any) {
    if (error.status === 502 || error.status === 504) {
      this.showGatewayError(error);
    } else if (error.status === 401) {
      this.sessionExpiration(error);
    } else if (error.status === 403) {
      this.showUnAuthourizedError(error);
    } else if (error.status === 500) {
      this.showinternalError(error);
    } else if (error.status === 0) {
      this.showNetworkError(error);
    } else {
      return Observable.throw(error.json());
    }
  }

  sessionExpiration(error: any) {
    const errorData = error;
    if (errorData.status === "success") {
    } else if (
      errorData.status === "false" &&
      errorData.err.includes("Invalid token")
    ) {
      const err = {
        code: 401,
        status: true,
        message: "Looks like your session has expired. Please login again.",
      };
      this.setErrorStatus(err);
    } else {
      const err = {
        code: 401,
        status: true,
        message: "Looks like your session has expired. Please login again.",
      };
      this.setErrorStatus(err);
    }
  }

  showGatewayError(error: any) {
    const err = {
      code: 502,
      status: true,
      message: "Unable to process your request, please try again.",
    };
    this.setErrorStatus(err);
  }

  showinternalError(error: any) {
    try {
      if (error.json()) {
        const errorData = error.json();
        if ((errorData.status = "fail")) {
        } else {
          const err = {
            code: 500,
            status: true,
            message: "Something went wrong. Please try again.",
          };
          this.setErrorStatus(err);
        }
      } else {
        console.log("Something went wrong. Please try again.");
      }
    } catch (ex) {
      console.log(ex);
    }
  }

  showNetworkError(error: any) {
    const err = {
      code: 0,
      status: true,
      message: "Connection is lost. Please reload the application.",
    };
    this.setErrorStatus(err);
  }

  showUnAuthourizedError(error: any) {
    const err = {
      code: 401,
      status: true,
      message:
        "Unauthorized access. Please login again with valid credentials.",
    };
    this.setErrorStatus(err);
  }

  redirectToLogin() {
    sessionStorage.clear();
    this.router.navigate(["login"]);
  }

  showServerError() {
    this.setErrorStatus(true);
  }

  getErrorStatus() {
    return this.ErrorStatusSubject.asObservable();
  }

  setErrorStatus(err) {
    this.ErrorStatusSubject.next(err);
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/services/errors.service.ts